<template>
    <dv-full-screen-container>
        <div class="linea-mainContainer">
            <div class="mainHead">
                <div class="headLeft">
                    <dv-decoration-8 :color="['#47A8ED', '#47A8ED']" style="width: 500px; height: 50px" />
                </div>
                <div class="middleOfHead">
                    <div class="headerText">
                        <img alt="塑业实时数据大屏" src="@/assets/img/logo.png" />
                        <p>塑业实时数据大屏</p>
                    </div>
                    <dv-decoration-5 :color="['#47A8ED', '#47A8ED']" :dur="10" style="width: 700px; height: 40px" />
                </div>
                <div class="headRight">
                    <dv-decoration-8
                        :color="['#47A8ED', '#47A8ED']"
                        :reverse="true"
                        style="width: 500px; height: 50px"
                    />
                </div>
            </div>
            <div class="contentBox">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="leftBox">
                            <div class="upperLeft">
                                <dv-border-box-12
                                    :color="['#0E4E80', '#1A92E8']"
                                    backgroundColor="rgba(5,21,57,0.3)"
                                    class="upperLeftBox"
                                >
                                    <div class="titleGroup">
                                        <div class="titleBox">切料控制台</div>
                                        <div class="toggleButtonGroup">
                                            <a
                                                :class="cuttingTabActive === 0 ? 'toggleActivation' : ''"
                                                @click="cuttingTabActive = 0"
                                            >
                                                实时值
                                            </a>
                                            <span>丨</span>
                                            <a
                                                :class="cuttingTabActive === 1 ? 'toggleActivation' : ''"
                                                @click="cuttingTabActive = 1"
                                            >
                                                设定值
                                            </a>
                                        </div>
                                    </div>
                                    <ul v-if="cuttingTabActive === 0" class="contentGroup">
                                        <li>
                                            <p>
                                                当前控制方式：<span>
                                                    {{ Number(lineH.blanking.data14) === 0 ? "停止" : "自动" }}
                                                </span>
                                            </p>
                                            <p>
                                                公转频率：<span>{{ lineH.motor.data110 }}Hz</span>
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                延时进刀时间显示：<span>{{ lineH.blanking.data1 }}S</span>
                                            </p>
                                            <p>
                                                进刀时间显示：<span>{{ lineH.motor.data2 }}S</span>
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                切割时间显示：<span>{{ lineH.blanking.data3 }}S</span>
                                            </p>
                                            <p>
                                                退刀时间显示：<span>{{ lineH.blanking.data4 }}S</span>
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                延时翻架时间显示：<span>{{ lineH.blanking.data5 }}S</span>
                                            </p>
                                            <p>
                                                翻架时间显示：<span>{{ lineH.blanking.data6 }}S</span>
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                计长显示：<span>{{ lineH.motor.data110 }}mm</span>
                                            </p>
                                            <p>
                                                切割计数：<span>{{ lineH.motor.data111 }}</span>
                                            </p>
                                        </li>
                                        <div class="controlStateGroup">
                                            <div class="controlGroupLeft">
                                                <li>
                                                    <p>切刀到位指示：</p>
                                                    <div
                                                        :class="
                                                            Number(lineH.blanking.data22) === 0
                                                                ? 'indicatorDot'
                                                                : 'indicatorDot indicatorDotActive'
                                                        "
                                                    />
                                                </li>
                                                <li>
                                                    <p>切割原点指示：</p>
                                                    <div
                                                        :class="
                                                            Number(lineH.blanking.data21) === 0
                                                                ? 'indicatorDot'
                                                                : 'indicatorDot indicatorDotActive'
                                                        "
                                                    />
                                                </li>
                                                <li>
                                                    <p>准 备 就 绪：</p>
                                                    <div
                                                        :class="
                                                            Number(lineH.blanking.data23) === 0
                                                                ? 'indicatorDot'
                                                                : 'indicatorDot indicatorDotActive'
                                                        "
                                                    />
                                                </li>
                                                <li>
                                                    <p>故 障 指 示：</p>
                                                    <div
                                                        :class="
                                                            Number(lineH.blanking.data24) === 0
                                                                ? 'indicatorDot'
                                                                : 'indicatorDot indicatorDotActive'
                                                        "
                                                    />
                                                </li>
                                            </div>
                                            <div class="controlGroupRight">
                                                <div
                                                    :class="
                                                        Number(lineH.blanking.data15) === 0
                                                            ? 'controlStatusButton'
                                                            : 'controlStatusButton controlStatusButtonActive'
                                                    "
                                                >
                                                    手动夹紧
                                                </div>
                                                <div
                                                    :class="
                                                        Number(lineH.blanking.data16) === 0
                                                            ? 'controlStatusButton'
                                                            : 'controlStatusButton controlStatusButtonActive'
                                                    "
                                                >
                                                    手动公转
                                                </div>
                                                <div
                                                    :class="
                                                        Number(lineH.blanking.data17) === 0
                                                            ? 'controlStatusButton'
                                                            : 'controlStatusButton controlStatusButtonActive'
                                                    "
                                                >
                                                    手动进刀
                                                </div>
                                                <div
                                                    :class="
                                                        Number(lineH.blanking.data18) === 0
                                                            ? 'controlStatusButton'
                                                            : 'controlStatusButton controlStatusButtonActive'
                                                    "
                                                >
                                                    手动退刀
                                                </div>
                                                <div
                                                    :class="
                                                        Number(lineH.blanking.data19) === 0
                                                            ? 'controlStatusButton'
                                                            : 'controlStatusButton controlStatusButtonActive'
                                                    "
                                                >
                                                    手动前进
                                                </div>
                                                <div
                                                    :class="
                                                        Number(lineH.blanking.data20) === 0
                                                            ? 'controlStatusButton'
                                                            : 'controlStatusButton controlStatusButtonActive'
                                                    "
                                                >
                                                    手动后退
                                                </div>
                                            </div>
                                        </div>
                                    </ul>
                                    <ul v-if="cuttingTabActive === 1" class="settingContentGroup">
                                        <li>
                                            <p>进刀时间：{{ lineH.blanking.data9 }}S</p>
                                            <p>退刀时间：{{ lineH.blanking.data11 }}S</p>
                                        </li>
                                        <li>
                                            <p>延时进刀：{{ lineH.blanking.data8 }}S</p>
                                            <p>切割时间：{{ lineH.blanking.data10 }}S</p>
                                        </li>
                                        <li>
                                            <p>延时翻架：{{ lineH.blanking.data12 }}S</p>
                                            <p>翻架时间：{{ lineH.blanking.data13 }}S</p>
                                        </li>
                                        <li>
                                            <p>计长设定：{{ lineH.blanking.data7 }}mm</p>
                                            <p>计长系数：{{ lineH.motor.data107 }}</p>
                                        </li>
                                    </ul>
                                </dv-border-box-12>
                            </div>
                            <div class="lowerLeft">
                                <dv-border-box-12 :color="['#0E4E80', '#1A92E8']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="lowerLeftBox">
                                        <div class="titleGroup">
                                            <div class="titleBox">参数信息</div>
                                            <div class="toggleButtonGroup">
                                                <a
                                                    :class="infoTabActive === 0 ? 'toggleActivation' : ''"
                                                    @click="infoTabActive = 0"
                                                >
                                                    主机参数
                                                </a>
                                                <span>丨</span>
                                                <a
                                                    :class="infoTabActive === 1 ? 'toggleActivation' : ''"
                                                    @click="infoTabActive = 1"
                                                >
                                                    牵引参数
                                                </a>
                                                <span>丨</span>
                                                <a
                                                    :class="infoTabActive === 2 ? 'toggleActivation' : ''"
                                                    @click="infoTabActive = 2"
                                                >
                                                    温度参数
                                                </a>
                                            </div>
                                        </div>
                                        <ul v-if="infoTabActive === 0" class="contentGroup">
                                            <li>
                                                <p>
                                                    主机额定转速设置：<span>{{ lineH.motor.data2 }}</span>
                                                </p>
                                                <p>
                                                    主机速度增量设置：<span>{{ lineH.motor.data3 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机额定电流设置：<span>{{ lineH.motor.data4 }}</span>
                                                </p>
                                                <p>
                                                    主机额定电流系数设置：<span>{{ lineH.motor.data5 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机报警电流设置：<span>{{ lineH.motor.data6 }}</span>
                                                </p>
                                                <p>
                                                    主机停机电流设置：<span>{{ lineH.motor.data7 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机报警压力设置：<span>{{ lineH.motor.data8 }}</span>
                                                </p>
                                                <p>
                                                    主机停机压力设置：<span>{{ lineH.motor.data9 }}</span>
                                                </p>
                                            </li>
                                        </ul>
                                        <ul v-if="infoTabActive === 1" class="contentGroup">
                                            <li>
                                                <p>
                                                    牵引额定转速设置：<span>{{ lineH.motor.data12 }}</span>
                                                </p>
                                                <p>
                                                    牵引速度增量设置：<span>{{ lineH.motor.data13 }}</span>
                                                </p>
                                            </li>
                                        </ul>
                                        <ul v-if="infoTabActive === 2" class="contentGroup">
                                            <li>
                                                <p>
                                                    入料口温度上限设置：<span>{{ lineH.motor.data14 }}</span>
                                                </p>
                                                <p>
                                                    温度上限设置：<span>{{ lineH.motor.data15 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    温度下限设置：<span>{{ lineH.motor.data16 }}</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </dv-border-box-12>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="middleBox">
                            <div class="upperMiddle">
                                <line-change-moudle />
                                <div class="floorPlan">
                                    <img alt="" src="../../assets/img/plan/plan@2x.png" />
                                </div>
                            </div>
                            <div class="middleDown">
                                <dv-border-box-11 :color="['#47A8ED', '#2972A6']" title="温度观测台">
                                    <div class="swiper-box">
                                        <swiper ref="mySwiper" :options="swiperOptions">
                                            <swiper-slide>
                                                <div class="temperatureGroup">
                                                    <temp-h
                                                        name="入料口"
                                                        :current-temp="lineH.xian.tc101"
                                                        :set-temp="lineH.xian.tc1"
                                                        :heating-state="lineH.sw.lqhrlk"
                                                        :heat-switch="lineH.sw.sw1"
                                                    />
                                                    <template v-for="index in 5">
                                                        <temp-h
                                                            :key="'h1' + index"
                                                            :name="`EH${index}`"
                                                            :current-temp="lineH.xian[`tc${index + 101}`]"
                                                            :set-temp="lineH.xian[`tc${index + 1}`]"
                                                            :heating-state="lineH.sw[`lqheh${index}`]"
                                                            :heat-switch="lineH.sw[`sw${index + 1}`]"
                                                        />
                                                    </template>
                                                    <temp-h
                                                        name="Ea"
                                                        :current-temp="lineH.xian.tc107"
                                                        :set-temp="lineH.xian.tc7"
                                                        :heating-state="lineH.sw.eahheat"
                                                        :heat-switch="lineH.sw.sw7"
                                                    />
                                                    <template v-for="index in 3">
                                                        <temp-h
                                                            :key="'h2' + index"
                                                            :name="`ED${index}`"
                                                            :current-temp="lineH.xian[`tc${index + 107}`]"
                                                            :set-temp="lineH.xian[`tc${index + 7}`]"
                                                            :heating-state="lineH.sw[`ed${index}hheat`]"
                                                            :heat-switch="lineH.sw[`sw${index + 7}`]"
                                                        />
                                                    </template>
                                                </div>
                                            </swiper-slide>
                                            <swiper-slide>
                                                <div class="temperatureGroup">
                                                    <template v-for="index in 10">
                                                        <temp-h
                                                            :key="'h3' + index"
                                                            :name="`ED${index + 3}`"
                                                            :current-temp="lineH.xian[`tc${index + 110}`]"
                                                            :set-temp="lineH.xian[`tc${index + 10}`]"
                                                            :heating-state="lineH.sw[`ed${index + 3}hheat`]"
                                                            :heat-switch="lineH.sw[`sw${index + 10}`]"
                                                        />
                                                    </template>
                                                </div>
                                            </swiper-slide>
                                            <swiper-slide>
                                                <div class="temperatureGroup">
                                                    <template v-for="index in 5">
                                                        <temp-h
                                                            :key="'h4' + index"
                                                            :name="`ED${index + 13}`"
                                                            :current-temp="lineH.xian[`tc${index + 120}`]"
                                                            :set-temp="lineH.xian[`tc${index + 20}`]"
                                                            :heating-state="lineH.sw[`ed${index + 13}hheat`]"
                                                            :heat-switch="lineH.sw[`sw${index + 20}`]"
                                                        />
                                                    </template>
                                                </div>
                                            </swiper-slide>
                                            <div slot="pagination" class="paginationDiy swiper-pagination"></div>
                                        </swiper>
                                    </div>
                                </dv-border-box-11>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="rightBox">
                            <div class="upperRight">
                                <dv-border-box-12 :color="['#0E4E80', '#2972A6']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="upperRightBox">
                                        <div class="titleBox">米重控制台</div>
                                        <div class="contentGroup">
                                            <li>
                                                <p>
                                                    当前牵引速度：<span>{{
                                                        Number(lineH.motor.data104).toFixed(2)
                                                    }}</span>
                                                </p>
                                                <p>
                                                    当前挤出速度：<span>{{ Number(lineH.line.var3).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    挤出率：<span>{{ Number(lineH.line.var4).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    当前挤出量：<span>{{ Number(lineH.line.var5).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    当前米重值：<span>{{ Number(lineH.line.var6).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    累计产量：<span>{{ Number(lineH.line.var7).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    设定米重值：<span>{{ Number(lineH.line.var1).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                        </div>
                                    </div>
                                </dv-border-box-12>
                            </div>
                            <div class="lowerRight">
                                <dv-border-box-12 :color="['#0E4E80', '#1A92E8']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="lowerRightBox">
                                        <div class="titleGroup">
                                            <div class="titleBox">电机控制台</div>
                                            <div class="toggleButtonGroup">
                                                <a
                                                    :class="motorTabActive === 0 ? 'toggleActivation' : ''"
                                                    @click="motorTabActive = 0"
                                                >
                                                    BRD75
                                                </a>
                                                <span>丨</span>
                                                <a
                                                    :class="motorTabActive === 1 ? 'toggleActivation' : ''"
                                                    @click="motorTabActive = 1"
                                                >
                                                    牵引
                                                </a>
                                                <span>丨</span>
                                                <a
                                                    :class="motorTabActive === 2 ? 'toggleActivation' : ''"
                                                    @click="motorTabActive = 2"
                                                >
                                                    熔体压力
                                                </a>
                                                <span>丨</span>
                                                <a
                                                    :class="motorTabActive === 3 ? 'toggleActivation' : ''"
                                                    @click="motorTabActive = 3"
                                                >
                                                    其他
                                                </a>
                                            </div>
                                        </div>
                                        <div v-if="motorTabActive === 0" class="contentGroup">
                                            <li>
                                                <p>
                                                    BRD75运行/停止：
                                                    <span>{{ lineH.sw.out1 == 0 ? "停止" : "运行" }}</span>
                                                </p>
                                                <p>
                                                    rmp：
                                                    <span>{{ lineH.motor.data1 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    rpm：
                                                    <span>{{ lineH.motor.data100 }}</span>
                                                </p>
                                                <p>
                                                    A：
                                                    <span>{{ lineH.motor.data101 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    %：
                                                    <span>{{ lineH.motor.data102 }}</span>
                                                </p>
                                                <p>
                                                    Mpa：
                                                    <span>{{ lineH.motor.data103 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    r/min：
                                                    <span>{{ lineH.motor.data100 }}</span>
                                                </p>
                                                <p>
                                                    A：
                                                    <span>{{ lineH.motor.data101 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    %：
                                                    <span>{{ lineH.motor.data102 }}</span>
                                                </p>
                                                <p>
                                                    ℃：
                                                    <span>{{ lineH.xian.tc101 }}</span>
                                                </p>
                                            </li>
                                        </div>
                                        <div v-if="motorTabActive === 1" class="contentGroup">
                                            <li>
                                                <p>
                                                    牵引运行/停止：
                                                    <span>{{ lineH.sw.out2 == 0 ? "停止" : "运行" }}</span>
                                                </p>
                                                <p>
                                                    m/min：
                                                    <span>{{ lineH.motor.data12 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    履带状态：
                                                    <span>{{ lineH.sw.out3 == 0 ? "停止" : "运行" }}</span>
                                                </p>
                                                <p>
                                                    模具风机启动/停止：
                                                    <span>{{ lineH.sw.out4 == 0 ? "停止" : "运行" }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    m/min：
                                                    <span>{{ lineH.motor.data104 }}</span>
                                                </p>
                                                <p>
                                                    速比：
                                                    <span>{{ lineH.motor.data105 }}</span>
                                                </p>
                                            </li>
                                        </div>
                                        <div v-if="motorTabActive === 2" class="contentGroup">
                                            <li>
                                                <p>
                                                    Mpa：
                                                    <span>{{ lineH.motor.data103 }}</span>
                                                </p>
                                            </li>
                                        </div>
                                        <div v-if="motorTabActive === 3" class="contentGroup">
                                            <li>
                                                <p>
                                                    时：
                                                    <span>{{ lineH.motor.data108 }}</span>
                                                </p>
                                                <p>
                                                    分：
                                                    <span>{{ lineH.motor.data109 }}</span>
                                                </p>
                                            </li>
                                        </div>
                                    </div>
                                </dv-border-box-12>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </dv-full-screen-container>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import { GET_LINE_H } from "@/api/public";
import TempH from "./components/Temp/TempAGH.vue";
import LineChangeMoudle from "./components/LineChangeMoudle.vue";

export default {
    name: "LineC",
    components: {
        Swiper,
        SwiperSlide,
        TempH,
        LineChangeMoudle
    },
    data() {
        return {
            lineH: {
                blanking: {
                    data1: 0,
                    data2: 0,
                    data3: 0,
                    data4: 0,
                    data5: 0,
                    data6: 0,
                    data7: 0,
                    data8: 0,
                    data9: 0,
                    data10: 0,
                    data11: 0,
                    data12: 0,
                    data13: 0,
                    data14: 0,
                    data15: 0,
                    data16: 0,
                    data17: 0,
                    data18: 0,
                    data19: 0,
                    data20: 0,
                    data21: 0,
                    data22: 0,
                    data23: 0,
                    data24: 0
                },
                motor: {
                    data1: 0,
                    data2: 0,
                    data3: 0,
                    data4: 0,
                    data5: 0,
                    data6: 0,
                    data7: 0,
                    data8: 0,
                    data9: 0,
                    data10: 0,
                    data11: 0,
                    data12: 0,
                    data13: 0,
                    data14: 0,
                    data15: 0,
                    data16: 0,
                    data100: 0,
                    data101: 0,
                    data102: 0,
                    data103: 0,
                    data104: 0,
                    data105: 0,
                    data106: 0,
                    data107: 0,
                    data108: 0,
                    data109: 0,
                    data110: 0,
                    data111: 0
                },
                line: {
                    var1: 0,
                    var2: 0,
                    var3: 0,
                    var4: 0,
                    var5: 0,
                    var6: 0,
                    var7: 0
                },
                xian: {},
                sw: {}
            },
            swiperOptions: {
                autoplay: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            },
            // 切料控制台tab
            cuttingTabActive: 0,
            // 参数信息tab
            infoTabActive: 0,
            // 电机控制台tab
            motorTabActive: 0
        };
    },
    mounted() {
        this.getLineH();
        setInterval(() => {
            this.getLineH();
        }, 60000);
    },
    methods: {
        getLineH() {
            GET_LINE_H({}).then((res) => {
                if (Number(res.data.code) !== 10000) {
                    this.$message.error(res.data.message);
                    return false;
                }
                this.lineH ={
                    blanking: res.data.data.blanking||{},
                    motor: res.data.data.motor||{},
                    line: res.data.data.line||{},
                    xian: res.data.data.xian||{},
                    sw: res.data.data.sw||{}
                };
            });
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/style/lineA.scss";
</style>
